import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ru from 'date-fns/locale/ru';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { YMInitializer } from 'react-yandex-metrika';

import Dialog from 'components/DialogProvider/Dialog';
import DialogProvider from 'components/DialogProvider/DialogProvider';
import ErrorNotification from 'components/ErrorProvider/ErrorNotification';
import ErrorProvider from 'components/ErrorProvider/ErrorProvider';
import { env } from 'config';
import NotificationsProvider from 'providers/NotificationsProvider';
import SessionProvider from 'providers/SessionProvider';
import Main from './main';
import CheckCookieProvider from './providers/CheckCookieProvider';
import StoreProvider from './store';
import MuiTheme from './theme';

/**
 * Основное дерево приложения: авторизация, хранилище, глобальные провайдеры и виджеты.
 * Страницы, открытые без авторизации, рендерятся отдельным деревом — см. PublicApp.
 */
const App: React.FC = () => (
  <CheckCookieProvider>
    <StoreProvider>
      <MuiTheme>
        <SessionProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ru}>
            <ErrorProvider>
              <DialogProvider>
                <BrowserRouter>
                  <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                    <NotificationsProvider>
                      <Main />
                    </NotificationsProvider>
                  </SnackbarProvider>
                </BrowserRouter>

                <Dialog />
              </DialogProvider>

              <ErrorNotification />
            </ErrorProvider>
          </MuiPickersUtilsProvider>
        </SessionProvider>
      </MuiTheme>
    </StoreProvider>

    <YMInitializer version="2" accounts={[Number(env.YANDEX_METRIKA_ID)]} />
  </CheckCookieProvider>
);

export default App;
